import EsusView from 'components/esus/EsusView'
import React from 'react'
import { useLocation } from 'react-router'

export default (props) => {
  const { search } = useLocation()

  return <EsusView url={`/pec/user/cds/cadastroDomiciliar/detail${search}`} />
}
